import * as React from "react";
import styled from "styled-components";
import { Spinner, ExternalLink } from "components/common";
import streamCategoryName from "logic/streams/streamCategoryName";
import { Col } from "common/components/layout-styles";
import { CELL_PADDING_HORIZONTAL } from "components/common/EntityDataTable/Constants";
import { scrollContainerWidthVar } from "components/common/EntityDataTable/CSSVariables";
import DetectionChainRulesList from "./DetectionChainRulesList";
import DetectionChainRulesHeader from "./DetectionChainRulesHeader";
import isSafeReferenceUrl from "./referenceUrl";
import { useGetDetectionChain } from "../../hooks/useDetectionChainsAPI";
const Wrapper = styled.div`
  position: sticky;
  left: 0;
  width: 100%;
  max-width: var(${scrollContainerWidthVar}, 100%);
  padding: ${CELL_PADDING_HORIZONTAL}px;
  background-color: ${({ theme }) => theme.colors.table.row.backgroundStriped};
`;
const DetailsBox = styled(Col)`
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.input.border};
`;
const Title = styled.h4`
  margin: 0;
`;
const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.sm};
  margin: 0 0 ${({ theme }) => theme.spacings.xxs} 0;
`;
const Meta = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 ${({ theme }) => theme.spacings.xs} 0;

  > div {
    margin: 0 0 ${({ theme }) => theme.spacings.xxs} 0;
  }
`;
const Description = styled.p`
  margin: 0;
`;
const Divider = styled.hr`
  margin: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.input.border};
`;
const DetectionChainExpansion = ({ name }) => {
  const { data, isLoading } = useGetDetectionChain(name);
  if (isLoading || !data)
    return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading chain details" }));
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(DetailsBox, null, /* @__PURE__ */ React.createElement(TitleRow, null, /* @__PURE__ */ React.createElement(Title, null, data.name), isSafeReferenceUrl(data.reference_url) && /* @__PURE__ */ React.createElement(ExternalLink, { href: data.reference_url }, "Reference")), /* @__PURE__ */ React.createElement(Meta, null, data.threat_actor && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Threat Actor:"), " ", data.threat_actor), data.targeted_technologies.length > 0 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Targeted Technologies:"), " ", data.targeted_technologies.join(", ")), data.industries.length > 0 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Industries:"), " ", data.industries.join(", ")), data.stream_categories.length > 0 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, "Stream Categories:"), " ", data.stream_categories.map(streamCategoryName).join(", "))), data.description && /* @__PURE__ */ React.createElement(Description, null, data.description), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(DetectionChainRulesHeader, { chainName: data.name }), /* @__PURE__ */ React.createElement(DetectionChainRulesList, { chainRules: data.rules })));
};
export default DetectionChainExpansion;
